import { flexRender, Row } from '@tanstack/react-table';
import { toast } from 'react-toastify';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import { IconButton, Tooltip, useDisclosure } from '@chakra-ui/react';
import { generatePath, Link } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import CustomModal from 'components/CustomModal';
import Td from 'pages/Dashboard/Listing/components/Table/components/Td';
import ROUTES from 'app/routes';
import { API, APIRoutes } from 'api';
import { ContentContainer } from 'types/contentComponent';

interface TableRowProps {
  row: Row<ContentContainer>;
  dashboardId: number;
}
function TableRow({ row, dashboardId }: TableRowProps) {
  const { id } = row.original;
  const { isOpen, onClose, onOpen } = useDisclosure();
  const queryClient = useQueryClient();

  const { mutate: removeContainer } = useMutation(
    () => API.delete(APIRoutes.dashboard.containers.byId(dashboardId, id)),
    {
      mutationKey: 'dashboardContainersMutation',
      onSuccess: () => {
        toast.success('Pomyślnie usunięto element');
        onClose();
        queryClient.invalidateQueries('dashboardContainers');
      },
      onError: () => {
        toast.error('Wystąpił problem podczas usuwania elementu');
      },
    },
  );

  return (
    <tr key={`row_${id}`}>
      {row.getVisibleCells().map((cell, idx, { length }) => {
        if (idx + 1 === length) return null;
        return (
          <Td key={`row_cell_${cell.id}_${cell}`}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </Td>
        );
      })}
      <Td>
        <>
          <CustomModal
            confirmationText="Usuń"
            onAccept={removeContainer}
            cancellationText="Anuluj"
            onClose={onClose}
            isOpen={isOpen}
            title="Czy na pewno chcesz trwale usunąć ten element?"
          />
          <Tooltip label="Edytuj" openDelay={1000}>
            <IconButton
              width="56px"
              height="40px"
              icon={<IconPencil />}
              aria-label="visiblity"
              variant="ghost"
              as={Link}
              to={generatePath(ROUTES.dashboard.containers.edit, {
                dashboardId,
                id,
              })}
            />
          </Tooltip>
          <Tooltip label="Usuń" openDelay={1000}>
            <IconButton
              width="56px"
              height="40px"
              icon={<IconTrash />}
              aria-label="visiblity"
              variant="ghost"
              onClick={onOpen}
            />
          </Tooltip>
        </>
      </Td>
    </tr>
  );
}

export default TableRow;
